import { Modal, Alert, Button, Form } from '@deere/ux.uxframe-react'
import React, { useState} from 'react'
import { useTranslation } from "react-i18next";
import { getTranslation } from '../../utils/utils';
import { saveUserAnswers } from '../../utils/saveSurveyUtils'
import store from '../../redux/store'
import { useSelector, useDispatch } from 'react-redux'
import { useUserInfo } from '../../providers/userProvider'
import { useOktaAuth } from '@okta/okta-react';
import { updateGenAnswer } from '../../redux/action/genericSurveyAction';
import { CRS_EXT_TOKEN } from '../../utils/constants';

function getAgreementQuestion(survey) {
    let section1 = !survey ? survey.sections.find(sec => sec.code === 'ctpat_sec1') : []
    return !section1 ? section1.questions.find(q => q.code === 'ctpat_que131') : []
}

export default function CtpatAgreementPopUp({handleClose,showAgreement, submitSurvey, survey}) {
    const { t } = useTranslation();
    const userInfo = useUserInfo();
    const dispatch = useDispatch()
    const { authState } = useOktaAuth();
    const surveyResponse = useSelector(state => state.genericSurvey.surveyResponses[survey.code]);
    const campaign = store.getState().campaign.campaignAssigned;
    const [showComments,setShowComments] = useState(false);
    const agreemenQuestion = getAgreementQuestion(survey);
    const [form,setForm] = useState({accept: true, reason: ''});
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let token = authState && authState.isAuthenticated ? authState.accessToken.accessToken : sessionStorage.getItem(CRS_EXT_TOKEN);

    const handleSubmit = event => {
        event.preventDefault();
        event.stopPropagation();
        if(form.accept){
            submitSurvey();
            handleClose();
        }else if(form.reason && form.reason !== ''){
            dispatch(updateGenAnswer({ questionId: agreemenQuestion.id, answer: form.reason, surveyCode: survey.code }));
            let answers = store.getState().genericSurvey.surveyAnswersForm[survey.code];
            saveUserAnswers(surveyResponse, answers, campaign, userInfo, isAuthMethodOkta, token).then(response => {
                submitSurvey();
                handleClose();
            }).catch(error => {
                console.log(error);
            });
        }
    }

    return (<Modal show={showAgreement} onHide={handleClose} size="lg">
                <Form validated={true} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('lbl_ctpat_agreemet_modal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body scrollable={false} style={{maxHeight: '325px',overflowY: "auto"}}>
                    <Alert variant="warning">
                        <h5 className="uxf-alert-title" align="justify">
                            {t('lbl_ctpat_agreemet_warning')} 
                        </h5>

                    </Alert>
                    <br/>
                    <Form.Group className="mb-4 pl-5">
                        <Form.Check required={true} type="radio" value='1' inline label='Yes' name='yes' 
                                    onClick={e=> setShowComments(false)} 
                                    onChange={e => setForm({...form, accept: true})}
                                    checked={form.accept === true}/>
                        <Form.Check required={true} type="radio" value='0' inline label='No' name='yes' 
                                    onClick={e=> setShowComments(true)}
                                    onChange={e => setForm({...form, accept: false})}
                                    checked={form.accept === false}/>
                    </Form.Group>
                    {showComments && <Form.Group controlId="textarea-example">
                                    <Form.Label className="uxf-label" >{getTranslation(agreemenQuestion, 'text')}</Form.Label>
                                    <Form.Control as="textarea" rows="3" aria-describedby="textarea-text" required={true}
                                    onChange={e => setForm({...form, reason: e.target.value})} value={form.reason} />
                                    <div className="invalid-feedback">{t('bs_required')}</div> 
                                </Form.Group>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>{t('btn_cancel')}</Button>
                    <Button variant="primary" onClick={handleSubmit} type='submit'>{t('btn_review_submit')}</Button>
                </Modal.Footer>
                </Form>
            </Modal>)
}